import BannerFooter from "@components/About/BannerFooter";
import FeaturedSustainability from "@components/About/Sustainability/FeaturedSustainability";
import Partnerships from "@components/About/Sustainability/Partnerships";
import Statistics from "@components/About/Sustainability/Statistics";
import SustainableExploration from "@components/About/Sustainability/SustainableExploration";
import SustainableItems from "@components/About/Sustainability/SustainableItems";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import { useRouteContext } from "@providers/RouteProvider";
import bannerFooterAboutStyles from "../../components/About/BannerFooter.module.scss";
import { usePageContext } from "@providers/PageProvider";
import helper, { sustainabilityPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const bannerFooter: any = sustainabilityPage.formatImageSection(pageData);
  return (
    <div className="" data-scroll-container>
      <Header />
      <Banner image={_.get(banner, "image")} title={_.get(banner, "title")} />
      <Breadcrumbs data={router.breadcrumbs("about-sustainability", {})} />
      <FeaturedSustainability />
      <Statistics />
      <SustainableItems />
      <Partnerships />
      <SustainableExploration />
      <BannerFooter
        className={bannerFooterAboutStyles.sustainabilityImage}
        image={bannerFooter}
      />
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
